import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es";

import { Row, Col } from 'reactstrap';
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";
import styles from '../doctor/adminStyles.css';
import Input from '../../components/Input/Input';
import WYSIWYG from '../../components/WYSIWYG/WYSIWYG';
import FileUpload from '../../components/FileUpload/FileUpload';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import * as actions from "../../actions/ApiActions";
import connect from 'react-redux/es/connect/connect';

class RegisterVerifiedContainer extends Component {


  render() {

    return (
      <Content>
        <Section>
          <div>
            <Headline center pageTitle>
              Willkommen bei Quickdoctor
            </Headline>
            <Headline center subtitle>Ihre Registrierung ist nun abgeschlossen. Sie können sich jetzt im Ärztebereich anmelden.</Headline>


            <Row>
            <Col xs={12}>
              <Button center href={'login'}>Jetzt anmelden</Button>
            </Col>
            </Row>
          </div>



        </Section>

      </Content>
    )
  }
}

export default RegisterVerifiedContainer



// WEBPACK FOOTER //
// ./src/container/public/RegisterVerifiedContainer.js